import { render, staticRenderFns } from "./Acordos.vue?vue&type=template&id=69542486&scoped=true"
import script from "./Acordos.vue?vue&type=script&lang=js"
export * from "./Acordos.vue?vue&type=script&lang=js"
import style0 from "./Acordos.vue?vue&type=style&index=0&id=69542486&prod&lang=css"
import style1 from "./Acordos.vue?vue&type=style&index=1&id=69542486&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69542486",
  null
  
)

export default component.exports